import type { IconName } from '@mdvip/shared/components/blocks/Icon';
import { NavTabs } from '@mdvip/shared/components/blocks/NavTabs';
import { useTranslation } from 'react-i18next';

export type WellbeingSection = 'nutrition' | 'wellness' | 'fitness';

interface WellbeingSubnavItem {
  id: WellbeingSection;
  to: string;
  icon: IconName;
  labelKey: string;
}

// Same order the Resources page lists them in, so the set does not reshuffle between the two.
const ITEMS = [
  { id: 'nutrition', to: '/resources/nutrition', icon: 'utensils', labelKey: 'pages.wellbeingSubnav.nutrition' },
  { id: 'wellness', to: '/resources/wellness', icon: 'bookOpen', labelKey: 'pages.wellbeingSubnav.wellness' },
  { id: 'fitness', to: '/resources/fitness', icon: 'dumbbell', labelKey: 'pages.wellbeingSubnav.fitness' },
] as const satisfies readonly WellbeingSubnavItem[];

interface WellbeingSubnavProps {
  active: WellbeingSection;
  className?: string;
}

/** Lateral navigation across the three Wellbeing hubs, sitting under the back link on each. */
export function WellbeingSubnav({ active, className }: WellbeingSubnavProps) {
  const { t } = useTranslation('members');

  return (
    <NavTabs
      label={t('pages.wellbeingSubnav.label')}
      active={active}
      items={ITEMS.map(({ labelKey, ...item }) => ({ ...item, label: t(labelKey) }))}
      className={className}
    />
  );
}
